import { MediaSourceType } from './types';
export var reduxKey = '@@MediaPopup';
export var MEDIA_POPUP_BROWSE_DEVIATION_STREAM_ID = 'MEDIA_POPUP_BROWSE_DEVIATION_STREAM_ID';
export var MEDIA_POPUP_BROWSE_SEARCH_DEVIATION_STREAM_ID = 'MEDIA_POPUP_BROWSE_SEARCH_DEVIATION_STREAM_ID';
export var MEDIA_POPUP_GALLECTION_DEVIATION_STREAM_GROUP = 'MEDIA_POPUP_GALLECTION_DEVIATION_STREAM_GROUP';
export var MEDIA_POPUP_GALLECTION_DEVIATION_SEARCH_STREAM_GROUP = 'MEDIA_POPUP_GALLECTION_DEVIATION_SEARCH_STREAM_GROUP';
export var MEDIA_POPUP_GALLECTION_STREAM_GROUP = 'MEDIA_POPUP_GALLECTION_STREAM_GROUP';
export var MEDIA_POPUP_CUSTOM_DEVIATION_SET_STREAM_ID = 'MEDIA_POPUP_CUSTOM_DEVIATION_SET_STREAM_ID';
export var DEVIATIONS_PER_FETCH = 24;
export var GALLECTIONS_PER_FETCH = 250;
export var MAX_SELECTED_ITEMS = 24;
export var DEVIATION_THUMB_HEIGHT = 120;
export var ACCEPTED_FILE_MIME_TYPES = [
    'image/jpg',
    'image/jpeg',
    'image/png',
    'image/gif',
];
export var DEFAULT_MEDIASOURCE_TYPES = [
    MediaSourceType.GALLERY,
    MediaSourceType.COLLECTION,
    MediaSourceType.STASH,
    MediaSourceType.BROWSE,
];
//# sourceMappingURL=constants.js.map